const WORDS = [
  "ΑΙΝΕΙΤΕ ΤΟΝ ΚΥΡΙΟ",
  "GOSPEL",
  "ΘΕΣΣΑΛΟΝΙΚΗ",
  "TRAVELERS GR",
  "ΨΑΛΜΟΣ 150",
  "ΑΛΛΗΛΟΥΙΑ",
];

export default function Marquee() {
  const sequence = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-[var(--line)] bg-[var(--surface)] py-10 md:py-16"
    >
      <div className="marquee-track">
        {sequence.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-5xl md:text-7xl lg:text-8xl text-[var(--fg)] px-8">
              {w}
            </span>
            <span className="text-[var(--ember)] text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
